import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class CountryServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params) {
    return this.http.get('/list', { params: params });
  }

  getCountriesCodes(params) {
    return this.http.get('/codes', { params });
  }

  getCountriesList(params) {
    return this.http.get('/', { params });
  }
  // select with user's countries
  getUserCountriesSelect() {
    return this.http.get('/select')
  }
}

export const CountryService = new CountryServiceClass({
  api_version: 2,
  resource: 'countries'
});
